export default "__VITE_ASSET__BqhmruLo__"